import api from '../common/helpers/apiHelper';
import { ITeam } from '../common/models/team/ITeam';
import { IUserInitials } from '../common/models/user/IUserInitials';

export const getTeams = () => api.get<{ teams: ITeam[], users: IUserInitials[] }>('/api/teams');

export const getTeamMembersCount = (id: string) => api.get<{ usersCount: number }>(`/api/teams/users-count/${id}`);

export const createTeam = (name: string) => api.post<ITeam>('/api/teams', { name });

export const updateTeam = (data: ITeam) => api.put<ITeam | undefined>('/api/teams', data);

export const deleteTeam = (id: string) => api.delete<void>(`/api/teams/${id}`);
